import React from 'react';
import { PageContext } from 'gatsby/internal';
import matchPageTemplate, { PageTemplate } from '../utils/match-page-template';

interface TemplateProviderReturnable {
    template: PageTemplate | undefined;
}

const TemplateContext = React.createContext(null as unknown as TemplateProviderReturnable);

const TemplateProvider = ({
    children,
    pageContext,
    pageResources,
    pathname,
}: { children: React.ReactNode, pageContext: PageContext, pageResources: unknown, pathname: string }): JSX.Element => {
    const value = React.useMemo(() => {
        const normalizedPathname = pathname.replace(/\/+$/, '') || '/';
        if (normalizedPathname === '/404' || normalizedPathname === '/404.html') {
            return { template: PageTemplate.NotFoundPage };
        }

        if (
            pageResources
        && typeof pageResources === 'object'
        && 'page' in pageResources
        && pageResources.page
        && typeof pageResources.page === 'object'
        && 'path' in pageResources.page
        && pageResources.page.path
        && typeof pageResources.page.path === 'string'
        && pageResources.page.path === '/404.html'
        ) {
            return {
                template: PageTemplate.NotFoundPage,
            };
        }
        return {
            template: matchPageTemplate(pageContext?.templateName),
        };
    }, [pageContext?.templateName, pageResources, pathname]);

    return (
        <TemplateContext.Provider value={value}>
            {children}
        </TemplateContext.Provider>
    );
};

export const useTemplateProvider = (): TemplateProviderReturnable => {
    const ctx = React.useContext(TemplateContext);
    if (!ctx) {
        throw new Error('No Template Context has been provided.');
    }
    return ctx;
};

export default TemplateProvider;
